export default __webpack_public_path__ + "static/media/contact_bubble_bg.c4aa6572.png";